/**
 * PDP Sticky Add to Cart
 * - Always visible on page load
 * - Variant changes sync price, availability, and ATC button state
 * - View Cart updates in real time
 * - Pushes up when cart notification is active
 * - On flybundle-tagged products: scrolls to third-party widget instead of submitting
 */
(function () {
  const stickyBar     = document.getElementById('pdp-sticky-atc');
  if (!stickyBar) return;

  const sectionId     = stickyBar.dataset.sectionId;
  const isSingleVariant = stickyBar.dataset.singleVariant === 'true';
  const stickyBtn     = stickyBar.querySelector('.pdp-sticky-atc__btn');
  const stickyInput   = stickyBar.querySelector('input[name="id"]');
  const priceEl       = stickyBar.querySelector('.pdp-sticky-atc__price');
  const cartNotif     = document.getElementById('cart-notification');
  const isFlybundle   = stickyBar.dataset.flybundle === 'true';

  // ── Show/hide on scroll — reveal only after main ATC scrolls out ──
  // Hidden on load; appears once user scrolls past the main ATC button.
  if (!isFlybundle) {
    stickyBar.style.transform   = 'translateY(100%)';
    stickyBar.style.pointerEvents = 'none';

    function getMainAtcBtn() {
      return document.getElementById('ProductSubmitButton-' + sectionId);
    }

    function checkStickyVisibility() {
      var atcBtn = getMainAtcBtn();
      if (!atcBtn) return;
      var rect = atcBtn.getBoundingClientRect();
      // Show when the bottom of the main ATC button has scrolled above the viewport
      if (rect.bottom < 0) {
        stickyBar.style.transform    = 'translateY(0)';
        stickyBar.style.pointerEvents = 'auto';
      } else {
        stickyBar.style.transform    = 'translateY(100%)';
        stickyBar.style.pointerEvents = 'none';
      }
    }

    window.addEventListener('scroll', checkStickyVisibility, { passive: true });

    // Also run once on load in case page is already scrolled
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', checkStickyVisibility);
    } else {
      checkStickyVisibility();
    }
  }

  // ── Flybundle: intercept ATC click and scroll to widget ───────
  if (isFlybundle && stickyBtn) {
    stickyBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const target = document.querySelector('.gfbFrequentBoughtAddToCartButtonSection');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true);

    window.addEventListener('scroll', () => {
      const widgetEl = document.querySelector('.gfbFrequentBoughtAddToCartButtonSection');
      if (!widgetEl) return;
      const widgetBottom = widgetEl.getBoundingClientRect().bottom;
      if (widgetBottom > 0) {
        stickyBar.style.transform = 'translateY(100%)';
        stickyBar.style.pointerEvents = 'none';
      } else {
        stickyBar.style.transform = 'translateY(0)';
        stickyBar.style.pointerEvents = 'auto';
      }
    }, { passive: true });

    const widgetEl = document.querySelector('.gfbFrequentBoughtAddToCartButtonSection');
    if (widgetEl && widgetEl.getBoundingClientRect().bottom > 0) {
      stickyBar.style.transform = 'translateY(100%)';
      stickyBar.style.pointerEvents = 'none';
    }
  }

  // ── MAIN FORM → STICKY ─────────────────────────────────────────
  function setupSubscriptions() {
    if (!window.subscribe || !window.PUB_SUB_EVENTS) {
      setTimeout(setupSubscriptions, 50);
      return;
    }
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event?.data?.variant;
      if (!variant) return;
      syncStickyToVariant(variant);
    });
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {});
  }
  setupSubscriptions();

  // MutationObserver fallback — product-info replaces [data-selected-variant] on DOM updates
  const productInfoEl = document.querySelector('product-info');
  if (productInfoEl) {
    let _lastVariantId = null;
    new MutationObserver(() => {
      const dataEl = productInfoEl.querySelector('[data-selected-variant]');
      if (!dataEl) return;
      try {
        const variant = JSON.parse(dataEl.innerHTML);
        if (variant && variant.id !== _lastVariantId) {
          _lastVariantId = variant.id;
          syncStickyToVariant(variant);
        }
      } catch(e) {}
    }).observe(productInfoEl, { childList: true, subtree: true });
  }

  // ── Format money ──────────────────────────────────────────────
  // Deterministic INR formatter — never shows ".00".
  // Previous implementation delegated to window.Shopify.formatMoney with a
  // no-decimals format string; app-injected formatMoney versions that don't
  // honour {{amount_no_decimals}} re-introduced the trailing .00 when the
  // section fetch / pub-sub sync re-wrote the price after the instant update.
  // Whole-rupee amounts → "₹1,099"; real paise preserved → "₹549.50".
  function formatMoney(cents) {
    var rounded = Math.round(cents);
    if (rounded % 100 === 0) {
      return '\u20B9' + (rounded / 100).toLocaleString('en-IN', {
        maximumFractionDigits: 0
      });
    }
    return '\u20B9' + (rounded / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
  }

  // ── Scroll gallery to the variant's image ───────────────────
  // Mirror of instantGalleryScroll in the swatch snippets.
  // Called here so the sticky bar can also trigger gallery updates.
  var _lastScrolledVariantId = null;

  // Exposed so swatch snippets can mark a variant as already-scrolled,
  // preventing the pub-sub handler from double-scrolling.
  window._faeMarkScrolled = function(variantId) {
    _lastScrolledVariantId = String(variantId);
  };

  function scrollGalleryToVariant(variant) {
    if (!variant) return;
    // Skip if we already scrolled to this variant (swatch click already did it)
    var vid = String(variant.id);
    if (vid === _lastScrolledVariantId) return;
    _lastScrolledVariantId = vid;

    // Get featured_media id from variant JSON
    var featuredMediaId = variant.featured_media && variant.featured_media.id
      ? String(variant.featured_media.id) : null;

    // Fallback: read from swatch element already in DOM
    if (!featuredMediaId && variant.id) {
      var swatchEl = document.querySelector(
        '[data-variant-id="' + variant.id + '"][data-featured-media-id]'
      );
      if (swatchEl) featuredMediaId = swatchEl.dataset.featuredMediaId;
    }

    if (!featuredMediaId) return;

    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    var sectionId = gallery.id.replace('MediaGallery-', '');
    var targetId  = sectionId + '-' + featuredMediaId;

    // Main viewer — instant scroll
    var viewer      = gallery.querySelector('[id^="GalleryViewer"]');
    var slider      = viewer && viewer.querySelector('.product__media-list');
    var targetSlide = slider && slider.querySelector('[data-media-id="' + targetId + '"]');
    if (slider && targetSlide) {
      slider.querySelectorAll('[data-media-id]').forEach(function(el) {
        el.classList.remove('is-active');
      });
      targetSlide.classList.add('is-active');
      slider.scrollTo({ left: targetSlide.offsetLeft, behavior: 'instant' });
    }

    // Thumbnail strip — smooth scroll
    var thumbs    = gallery.querySelector('[id^="GalleryThumbnails"]');
    var thumbList = thumbs && thumbs.querySelector('.thumbnail-list');
    if (thumbList) {
      thumbList.querySelectorAll('button').forEach(function(b) {
        b.removeAttribute('aria-current');
      });
      var thumbItem = thumbList.querySelector('[data-target="' + targetId + '"]');
      if (thumbItem) {
        var btn = thumbItem.querySelector('button');
        if (btn) btn.setAttribute('aria-current', 'true');
        thumbList.scrollTo({ left: thumbItem.offsetLeft, behavior: 'smooth' });
      }
    }

    // Page scroll — bring image into view if above viewport.
    // When sticky bar is visible, scroll to top of page instead of mid-page gallery offset.
    if (targetSlide) {
      window.setTimeout(function() {
        var rect = targetSlide.getBoundingClientRect();
        if (rect.top > -0.5) return;
        var stickyBarEl = document.getElementById('pdp-sticky-atc');
        var isSticky = stickyBarEl && (stickyBarEl.style.transform === 'translateY(0px)' || stickyBarEl.style.transform === 'translateY(0)');
        if (isSticky) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          window.scrollTo({ top: rect.top + window.scrollY, behavior: 'smooth' });
        }
      });
    }
  }

  // ── Sync sticky bar state from variant object ─────────────────
  function syncStickyToVariant(variant) {
    // Keep gallery in sync (canonical fix — must not be removed)
    scrollGalleryToVariant(variant);

    // Update hidden variant ID input
    if (stickyInput) {
      stickyInput.value    = variant.id;
      stickyInput.disabled = !variant.available;
    }

    // Update ATC button
    if (stickyBtn) {
      if (!isFlybundle) {
        const textEl = stickyBtn.querySelector('span:first-child');
        if (textEl) {
          textEl.textContent = variant.available
            ? 'Add To Bag - ' + formatMoney(variant.price)
            : (window.variantStrings?.soldOut || 'Sold out');
        }
      }
      variant.available
        ? stickyBtn.removeAttribute('disabled')
        : stickyBtn.setAttribute('disabled', '');
    }

    // Update price display
    if (priceEl && variant.price) {
      priceEl.textContent = formatMoney(variant.price);
    }

    // Update sticky variant dropdown display to match
    var stickyMenu = document.getElementById('pdp-sticky-variant-menu-' + sectionId);
    if (stickyMenu) {
      var vid = String(variant.id);
      var item = stickyMenu.querySelector('[data-variant-id="' + vid + '"]');
      if (item) {
        var swEl = document.getElementById('pdp-sticky-variant-swatch-' + sectionId);
        var lbEl = document.getElementById('pdp-sticky-variant-label-' + sectionId);
        if (swEl) swEl.style.backgroundImage = 'url(\'' + item.dataset.swatchImage + '\')';
        if (lbEl) lbEl.textContent = item.dataset.primaryText || vid;
        stickyMenu.querySelectorAll('.pdp-sticky-variant__item').forEach(function(i) {
          i.classList.toggle('pdp-sticky-variant__item--selected', i.dataset.variantId === vid);
        });
      }
    }
  }

  // ── Initialise sticky state on page load ─────────────────────
  // Always pre-select a variant: use ?variant= from URL if present,
  // otherwise fall through to the first variant in the dropdown menu.
  function initStickyState() {
    const dataEl = document.querySelector('[data-selected-variant]');
    let selectedVariant = null;
    if (dataEl) {
      try { selectedVariant = JSON.parse(dataEl.textContent); } catch(e) {}
    }

    if (selectedVariant) {
      // URL had ?variant= — sync sticky to that variant
      syncStickyToVariant(selectedVariant);
    } else if (!isSingleVariant) {
      // No URL param — leave sticky bar in "Select a Shade" state
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyState);
  } else {
    initStickyState();
  }

  // ── Patch product-info.updateMedia — skip DOM slide re-sorting ──
  // Dawn's updateMedia re-sorts slides in the DOM and calls setActiveMedia,
  // both of which fight instantGalleryScroll. We patch the instance to only
  // keep the modal content update, which is the only thing we still need.
  function patchProductInfoUpdateMedia() {
    const productInfo = document.querySelector('product-info');
    if (!productInfo || productInfo._faePatched) return;
    productInfo._faePatched = true;

    const proto = Object.getPrototypeOf(productInfo);
    const originalUpdateMedia = proto.updateMedia;
    if (typeof originalUpdateMedia !== 'function') return;

    productInfo.updateMedia = function(html, variantFeaturedMediaId) {
      // Skip slide DOM sorting and setActiveMedia — instantGalleryScroll handles the gallery.
      // Only preserve the modal content update.
      const modalContent    = this.productModal?.querySelector('.product-media-modal__content');
      const newModalContent = html?.querySelector('product-modal .product-media-modal__content');
      if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchProductInfoUpdateMedia);
  } else {
    patchProductInfoUpdateMedia();
  }

  // ── Push bar up when cart notification is active ──────────────
  function updateBottomOffset() {
    stickyBar.style.bottom = cartNotif?.classList.contains('active')
      ? cartNotif.offsetHeight + 'px'
      : '0px';
  }

  if (cartNotif) {
    new MutationObserver(updateBottomOffset).observe(cartNotif, {
      attributes: true, attributeFilter: ['class']
    });
    updateBottomOffset();
  }

  // ── Sticky variant dropdown ───────────────────────────────────────
  (function initStickyVariantDropdown() {
    var wrapper = document.getElementById('pdp-sticky-variant-' + sectionId);
    if (!wrapper) return; // single-variant — not rendered

    var trigger   = document.getElementById('pdp-sticky-variant-trigger-' + sectionId);
    var menu      = document.getElementById('pdp-sticky-variant-menu-' + sectionId);
    var swatchEl  = document.getElementById('pdp-sticky-variant-swatch-' + sectionId);
    var labelEl   = document.getElementById('pdp-sticky-variant-label-' + sectionId);

    // ── Toggle open/close ──────────────────────────────────────────
    trigger && trigger.addEventListener('click', function(e) {
      e.stopPropagation();
      wrapper.classList.toggle('pdp-sticky-variant--open');
    });
    document.addEventListener('click', function(e) {
      if (!wrapper.contains(e.target)) {
        wrapper.classList.remove('pdp-sticky-variant--open');
      }
    });

    // ── Item click → select variant ────────────────────────────────
    menu && menu.addEventListener('click', function(e) {
      var item = e.target.closest('.pdp-sticky-variant__item');
      if (!item) return;
      var variantId = item.dataset.variantId;
      if (!variantId) return;

      // Close menu
      wrapper.classList.remove('pdp-sticky-variant--open');

      // Update sticky dropdown display
      updateStickyDropdownDisplay(variantId);

      // Sync the PDP swatch/dropdown selection to match
      syncPdpToVariant(variantId);
    });

    // ── Update sticky dropdown trigger display ─────────────────────
    function updateStickyDropdownDisplay(variantId) {
      var item = menu && menu.querySelector('[data-variant-id="' + variantId + '"]');
      if (!item) return;
      if (swatchEl) swatchEl.style.backgroundImage = 'url(\'' + item.dataset.swatchImage + '\')';
      if (labelEl)  labelEl.textContent = item.dataset.primaryText || variantId;
      // Selected state
      menu.querySelectorAll('.pdp-sticky-variant__item').forEach(function(i) {
        i.classList.toggle('pdp-sticky-variant__item--selected', i.dataset.variantId === variantId);
      });
    }
    // Expose so PDP swatch/dropdown snippets can call directly without pub-sub
    window._faeSyncStickyDropdown = updateStickyDropdownDisplay;

    // ── Sync PDP swatch/dropdown to same variant ───────────────────
    // Fires the existing PDP selectVariant so price, ATC, gallery all update.
    function syncPdpToVariant(variantId) {
      // Try clicking the matching cs-swatch or cs-dropdown-item on the PDP
      var pdpSwatch = document.querySelector('.cs-swatch[data-variant-id="' + variantId + '"]');
      if (pdpSwatch) { pdpSwatch.click(); return; }
      var pdpItem = document.querySelector('.cs-dropdown-item[data-variant-id="' + variantId + '"]');
      if (pdpItem)  { pdpItem.click(); return; }
      // Fallback: publish variantChange if pub-sub is available
      if (window.subscribe && window.PUB_SUB_EVENTS) {
        var item = menu && menu.querySelector('[data-variant-id="' + variantId + '"]');
        if (item) {
          try {
            if (typeof publish !== 'undefined') {
              publish(PUB_SUB_EVENTS.variantChange, {
                data: { sectionId: sectionId, variant: { id: parseInt(variantId), available: item.dataset.available === 'true' } }
              });
            }
          } catch(err) {}
        }
      }
    }

    // ── Keep sticky dropdown in sync when PDP swatch/dropdown changes ─
    function subscribeToVariantChange() {
      if (!window.subscribe || !window.PUB_SUB_EVENTS) {
        setTimeout(subscribeToVariantChange, 50);
        return;
      }
      subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
        var variant = event && event.data && event.data.variant;
        if (variant && variant.id) {
          updateStickyDropdownDisplay(String(variant.id));
        }
      });
    }
    subscribeToVariantChange();

    // ── Init: pre-select if a variant is already selected ─────────
    function initDisplay() {
      var dataEl = document.querySelector('[data-selected-variant]');
      if (dataEl) {
        try {
          var v = JSON.parse(dataEl.textContent);
          if (v && v.id) { updateStickyDropdownDisplay(String(v.id)); return; }
        } catch(e) {}
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDisplay);
    } else {
      initDisplay();
    }
  })();

  // ── Qty stepper + sync ─────────────────────────────────────────
  // Handles +/- clicks for BOTH the main ATC and sticky ATC steppers,
  // and keeps them in sync. Runs here (not in buy-buttons.liquid) so it
  // works for all products regardless of variant count or tags.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.fae-qty-btn');
    if (!btn) return;
    var stepper = btn.closest('.fae-qty-stepper');
    var input   = stepper && stepper.querySelector('.fae-qty-input');
    if (!input) return;

    var val = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || 999;

    if (btn.classList.contains('fae-qty-minus')) {
      val = Math.max(min, val - 1);
    } else {
      val = Math.min(max, val + 1);
    }
    input.value = val;

    // Sync all other qty inputs on the page to the same value
    document.querySelectorAll('.fae-qty-input').forEach(function (other) {
      if (other !== input) other.value = val;
    });
  });

  // Sync on direct manual typing
  document.addEventListener('change', function (e) {
    if (!e.target.classList.contains('fae-qty-input')) return;
    var val = Math.max(1, parseInt(e.target.value, 10) || 1);
    e.target.value = val;
    document.querySelectorAll('.fae-qty-input').forEach(function (other) {
      if (other !== e.target) other.value = val;
    });
  });
})();

// ── PDP Gallery prev/next arrow navigation ────────────────────────────────
;(function () {
  function initGalleryNav() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    var sectionId = gallery.id.replace('MediaGallery-', '');
    var slider    = document.getElementById('Slider-Gallery-' + sectionId);
    var thumbList = gallery.querySelector('.thumbnail-list');
    var prevBtn   = document.getElementById('FaeGalleryPrev-' + sectionId);
    var nextBtn   = document.getElementById('FaeGalleryNext-' + sectionId);

    if (!slider || !prevBtn || !nextBtn) return;

    // ── Helpers ────────────────────────────────────────────────────
    function getSlides() {
      return Array.from(slider.querySelectorAll('.product__media-item[data-media-id]'));
    }

    function getCurrentIndex() {
      var all = getSlides();
      var idx = all.findIndex(function (s) { return s.classList.contains('is-active'); });
      return idx >= 0 ? idx : 0;
    }

    function goTo(idx) {
      var all = getSlides();
      if (all.length <= 1) return;

      // Wraparound
      idx = (idx + all.length) % all.length;
      var target  = all[idx];
      var mediaId = target.dataset.mediaId;

      // ── Activate slide in main viewer ─────────────────────────
      all.forEach(function (s) { s.classList.remove('is-active'); });
      target.classList.add('is-active');
      slider.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });

      // ── Sync thumbnail strip ──────────────────────────────────
      if (thumbList) {
        thumbList.querySelectorAll('button.thumbnail').forEach(function (b) {
          b.removeAttribute('aria-current');
        });
        var thumbItem = thumbList.querySelector('[data-target="' + mediaId + '"]');
        if (thumbItem) {
          var thumbBtn = thumbItem.querySelector('button.thumbnail');
          if (thumbBtn) thumbBtn.setAttribute('aria-current', 'true');
          // Scroll within the thumbnail strip only — not the page
          thumbList.scrollTo({ left: thumbItem.offsetLeft, behavior: 'smooth' });
        }
      }

      // ── Trigger any deferred media if video ──────────────────
      var deferredMedia = target.querySelector('deferred-media');
      if (deferredMedia && typeof deferredMedia.loadContent === 'function') {
        // Don't auto-load — just ensure the poster is visible.
        // User can click to play.
      }
    }

    // ── Attach arrow listeners ─────────────────────────────────────
    prevBtn.addEventListener('click', function () {
      goTo(getCurrentIndex() - 1);
    });
    nextBtn.addEventListener('click', function () {
      goTo(getCurrentIndex() + 1);
    });

    // ── Keyboard: left/right when gallery has focus ────────────────
    gallery.addEventListener('keydown', function (e) {
      if (document.activeElement.closest('media-gallery') !== gallery) return;
      if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(getCurrentIndex() - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(getCurrentIndex() + 1); }
    });

    // NOTE: intentionally no custom touchstart/touchend swipe handler here.
    // The slider already has native scroll-snap (scroll-snap-type: x mandatory,
    // component-slider.css) and Dawn's own <slider-component> (global.js) listens
    // to its native `scroll` event and dispatches `slideChanged`, which
    // media-gallery.js uses to keep thumbnails in sync. A second, independently
    // tracked touch handler here previously called its own slider.scrollTo()
    // in response to the same swipe gesture, racing Dawn's native scroll-snap
    // settle. The two competing scrollTo calls could cancel each other out
    // mid-swipe, and since this script's index was tracked via a separate
    // `.is-active` class (not actual scroll position), that index would then
    // desync from the real slide — causing the gallery to freeze on one image
    // for the rest of the session even though the user kept swiping. Removing
    // it restores native swipe behavior; arrows/keyboard nav above still work
    // exactly as before since those are discrete events, not concurrent scroll.
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryNav);
  } else {
    initGalleryNav();
  }
})();

// ── Deferred-media unmute patch ───────────────────────────────────────────
// Patches every deferred-media on the PDP so clicking play starts unmuted.
// Root cause of previous muting bug: calling video.play() on an already-playing
// video throws AbortError → catch sets muted=true → video stays muted.
// Fix: only call play() when the video is actually paused.
;(function () {
  function unmuteVideo(dm) {
    var video = dm.querySelector('video:not(.fae-thumb-video)');
    if (!video) return;

    // Remove Shopify's hardcoded muted attribute
    video.removeAttribute('muted');
    video.muted  = false;
    video.volume = 1;

    // Only call play() if not already playing — calling it mid-play throws
    // AbortError whose catch block re-mutes the video
    if (video.paused) {
      video.play().catch(function () {
        // Browser blocked unmuted play — mute and retry. Set both the JS
        // property AND the HTML attribute; some WebKit/mobile Safari
        // versions only grant muted-autoplay eligibility when the actual
        // attribute is present, not just the .muted IDL property.
        video.muted = true;
        video.setAttribute('muted', '');
        video.play().catch(function () {});
      });
    }

    // Restart muted thumbnail videos pauseAllMedia may have suspended
    document.querySelectorAll('.fae-thumb-video').forEach(function (v) {
      if (v.paused) { v.muted = true; v.play().catch(function () {}); }
    });
  }

  function patchOne(dm) {
    if (!dm || dm._faeUnmutePatched || typeof dm.loadContent !== 'function') return;
    dm._faeUnmutePatched = true;
    var orig = dm.loadContent.bind(dm);
    dm.loadContent = function (focus) {
      orig(focus);

      var video = dm.querySelector('video:not(.fae-thumb-video)');
      if (!video) return; // iframe (external video) or nothing injected — nothing to patch here

      // Wait for the video to actually have playable data before attempting
      // to unmute/play it, instead of guessing a fixed delay. The previous
      // fixed 50ms timeout was tuned against fast desktop connections —
      // on real mobile devices (slower CPU + actual cellular/mobile network
      // latency, compounded by preload:'none' meaning nothing is pre-fetched)
      // the video element frequently doesn't have any data yet at 50ms, so
      // both the unmuted play() attempt and its muted-fallback retry could
      // fail simply because there was nothing to play, not because of
      // autoplay policy. This is what caused a clean desktop-works /
      // mobile-fails split rather than random flakiness on both.
      var attempted = false;
      function tryUnmute() {
        if (attempted) return;
        attempted = true;
        unmuteVideo(dm);
      }
      if (video.readyState >= 2) {
        // HAVE_CURRENT_DATA or better — already safe to attempt now.
        tryUnmute();
      } else {
        video.addEventListener('loadeddata', tryUnmute, { once: true });
        video.addEventListener('canplay', tryUnmute, { once: true });
        // Safety net in case neither event ever fires (e.g. a network
        // failure we have no other signal for) — don't wait forever.
        setTimeout(tryUnmute, 2500);
      }
    };
  }

  function patchAll() {
    document.querySelectorAll('deferred-media').forEach(patchOne);
  }

  // Wait for Dawn to register deferred-media before patching existing elements
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('deferred-media').then(patchAll);
  }
  // Also run immediately in case already defined
  patchAll();

  // Patch any deferred-media injected dynamically after page load
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.tagName === 'DEFERRED-MEDIA') patchOne(node);
        if (node.querySelectorAll) node.querySelectorAll('deferred-media').forEach(patchOne);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();